import {
  IGameCommunicationProcessor,
  GameCommunicationMessageType,
} from '@pp/core/src/controllers/gameCommunication/types';

import { GameStore } from '../../../store/GameStore';
import { airPlaneActions } from '../../../store/slices/highflyerAirPlane/slice';
import { airplaneStates } from '../../../store/slices/highflyerAirPlane/types';
import { highflyerStateActions } from '../../../store/slices/highflyerState/slice';

type Multiplier = GameCommunicationMessageType & {
  mul: string;
};

export class GameCommunicationMultiplierProcessor implements IGameCommunicationProcessor {
  messageName = 'hf_mul';
  delay = 100;

  process(message: Multiplier, store: GameStore): void {
    const processDelay: number = 0;
    const { highflyerAirPlane } = store.getState();
    if (highflyerAirPlane.currentState !== airplaneStates.FLEW_AWAY) {
      store.dispatch(airPlaneActions.setCurrentState(airplaneStates.FLYING));
    }
    setTimeout(() => {
      this.handleBetsStats(message, store);
    }, processDelay);
  }

  private handleBetsStats(message: Multiplier, store: GameStore): void {
    store.dispatch(highflyerStateActions.setMultiplier(message.mul));
  }
}
